export type IconProps = {
  [key: string]: string
}

const iconsMap: IconProps = {
  'em---1': 'likes',
  'em-heart': 'hearts',
  'em-angry': 'angry',
  'em-astonished': 'surprise',
}

export {iconsMap};